module.exports = __webpack_public_path__ + "kr-background-02-darker-02.ec6ae2c.jpg";